require("./modules/core")
require("./email_brilliance/submit_form.js")
